/* Product page v2 sliders (reviews, goes well with): arrow buttons scroll the
   track by one card. Delegated, so it covers sliders whose content loads
   later (recommendations) and only binds once however many sections load it. */
(() => {
  if (window.__pdpSlider) return;
  window.__pdpSlider = true;
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-pdp-slide]');
    if (!btn) return;
    const track = btn.closest('.pdp-slider') && btn.closest('.pdp-slider').querySelector('.pdp-slider__track');
    if (!track) return;
    const card = track.firstElementChild;
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    const step = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    track.scrollBy({ left: step * Number(btn.dataset.pdpSlide), behavior: 'smooth' });
  });
})();
